/**
 * try/catch-wrapped localStorage access. Private browsing / blocked storage
 * must never throw out of here — callers (e.g. useTheme) get `null` on a
 * failed read and silently no-op on a failed write instead (FR-006).
 */
export function getItem(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function setItem(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // swallow — current-visit behavior must still work without persistence
  }
}
